/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VirtualContainerReason } from '../../models/virtual-container-reason';

export interface GetVirtualContainerReasons$Params {
}

export function getVirtualContainerReasons(http: HttpClient, rootUrl: string, params?: GetVirtualContainerReasons$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VirtualContainerReason>>> {
  const rb = new RequestBuilder(rootUrl, getVirtualContainerReasons.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VirtualContainerReason>>;
    })
  );
}

getVirtualContainerReasons.PATH = '/api/v1/VirtualContainer/Reasons';
